var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSession = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1C20.6569 1 22 2.34315 22 4V13C22 14.6569 20.6569 16 19 16H14.15L18.7462 21.3486C19.0785 21.7353 19.0634 22.303 18.7296 22.6711L18.6396 22.7588C18.2529 23.0911 17.6852 23.0759 17.317 22.7422L17.2294 22.6521L13 17.731V22.0004C13 22.5132 12.614 22.9359 12.1166 22.9936L12 23.0004C11.4872 23.0004 11.0645 22.6143 11.0067 22.117L11 22.0004V17.683L6.75843 22.6195C6.39847 23.0384 5.76711 23.0862 5.34824 22.7262C4.92937 22.3662 4.88162 21.7349 5.24157 21.316L9.809 16H5C3.34315 16 2 14.6569 2 13V4C2 2.34315 3.34315 1 5 1H19ZM20 7.034H4V13C4 13.5523 4.44772 14 5 14H19C19.5523 14 20 13.5523 20 13V7.034ZM19 3H5C4.44772 3 4 3.44772 4 4V5.034H20V4C20 3.44772 19.5523 3 19 3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSession);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconSession.aac51f76f96651e6371208b7e35ef981.svg";